import React, { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import CommissionTemplates from './CommissionTemplates';
import AgentPlanView from './AgentPlanView';

const CommissionPlansSection: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('templates');

  useEffect(() => {
    // Parse the URL to determine active tab
    const pathParts = location.pathname.split('/');
    const commissionIndex = pathParts.indexOf('commission-plans');
    
    if (commissionIndex !== -1 && pathParts[commissionIndex + 1]) {
      const subTab = pathParts[commissionIndex + 1];
      if (subTab === 'agent-plans' || subTab === 'agents') {
        setActiveKey('agent-plans');
      } else {
        setActiveKey('templates');
      }
    }

    // Check for the custom event to switch tabs
    const handleSwitchToAgentPlans = (event: any) => {
      setActiveKey('agent-plans');
      // Navigate to the agent-plans sub-route
      navigate('/broker-intelligence/commission-plans/agent-plans' + location.search);
    };

    window.addEventListener('switchToAgentPlans', handleSwitchToAgentPlans);
    return () => {
      window.removeEventListener('switchToAgentPlans', handleSwitchToAgentPlans);
    };
  }, [location, navigate]);

  const handleTabSelect = (eventKey: string | null) => {
    if (!eventKey) return;
    
    setActiveKey(eventKey);
    
    // Update the URL based on the selected tab
    const basePath = '/broker-intelligence/commission-plans';
    const subPath = eventKey === 'agent-plans' ? '/agent-plans' : '/templates';
    navigate(basePath + subPath + location.search);
  };

  return (
    <Tab.Container activeKey={activeKey} onSelect={handleTabSelect}>
      <Nav variant="pills" className="mb-4">
        <Nav.Item>
          <Nav.Link eventKey="templates">Commission Templates</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="agent-plans">Agent Plans</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="templates">
          <CommissionTemplates />
        </Tab.Pane>
        <Tab.Pane eventKey="agent-plans">
          <AgentPlanView />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default CommissionPlansSection;